export default api => {
  if (!api) {
    return;
  }

  const selectionRange = api.getCellRanges();
  if (!selectionRange.length) {
    return;
  }
  const selectedCell = selectionRange[0];
  const selectedCellData = selectedCell ? {
    rowIndex: selectedCell.startRow.rowIndex,
    colKey: selectedCell.startColumn.colId,
  } : null;
  api.startEditingCell(selectedCellData);
};

